import { render, staticRenderFns } from "./TransferInsuranceReport.vue?vue&type=template&id=18e97fcb"
import script from "./TransferInsuranceReport.vue?vue&type=script&lang=js"
export * from "./TransferInsuranceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports